import { Repository } from "./adapters/repository";
import { DuplicateInspector } from "./adapters/duplicateInspector";

import * as retrieveProjectPortfolios from "./useCases/retrieveProjectPortfolios";
import * as createProjectPortfolio from "./useCases/createProjectPortfolio";
import * as editProjectPortfolio from "./useCases/editProjectPortfolio";
import * as removeProjectPortfolio from "./useCases/removeProjectPortfolio";
import * as assignProjectToPortfolio from "./useCases/assignProjectToPortfolio";
import * as removeProjectFromPortfolio from "./useCases/removeProjectFromPortfolio";

enum UseCases {
  retrieveProjectPortfolios = "retrieveProjectPortfolios",
  createProjectPortfolio = "createProjectPortfolio",
  assignProjectToPortfolio = "assignProjectToPortfolio",
  removeProjectPortfolio = "removeProjectPortfolio",
  removeProjectFromPortfolio = "removeProjectFromPortfolio",
  editProjectPortfolio = "editProjectPortfolio",
}

interface Core {
  [UseCases.retrieveProjectPortfolios]: retrieveProjectPortfolios.Interactor;
  [UseCases.createProjectPortfolio]: createProjectPortfolio.Interactor;
  [UseCases.assignProjectToPortfolio]: assignProjectToPortfolio.Interactor;
  [UseCases.removeProjectPortfolio]: removeProjectPortfolio.Interactor;
  [UseCases.removeProjectFromPortfolio]: removeProjectFromPortfolio.Interactor;
  [UseCases.editProjectPortfolio]: editProjectPortfolio.Interactor;
}

type Boundaries = BoundaryMap<Core>;

type Dependencies = {
  repository: Repository;
  duplicateInspector: DuplicateInspector;
};

function createCore(dependencies: Dependencies): Core {
  return {
    [UseCases.retrieveProjectPortfolios]:
      retrieveProjectPortfolios.createInteractor(dependencies.repository),
    [UseCases.createProjectPortfolio]: createProjectPortfolio.createInteractor(
      dependencies.repository,
      dependencies.duplicateInspector,
    ),
    [UseCases.assignProjectToPortfolio]:
      assignProjectToPortfolio.createInteractor(dependencies.repository),
    [UseCases.removeProjectPortfolio]: removeProjectPortfolio.createInteractor(
      dependencies.repository,
    ),
    [UseCases.removeProjectFromPortfolio]:
      removeProjectFromPortfolio.createInteractor(dependencies.repository),
    [UseCases.editProjectPortfolio]: editProjectPortfolio.createInteractor(
      dependencies.repository,
      dependencies.duplicateInspector,
    ),
  };
}

export type { Core, Boundaries, Dependencies };

export { UseCases, createCore };
